import React from "react";
import { partners } from "../mock";

// Continuously scrolling logo strip.
// Strategy: try Clearbit first (best when available), fallback to Google's
// favicon service (works for virtually every site), then to a clean text card.

function LogoTile({ partner }) {
  const [stage, setStage] = React.useState(0); // 0=clearbit, 1=favicon, 2=text
  const sources = [
    `https://logo.clearbit.com/${partner.domain}?size=200`,
    `https://www.google.com/s2/favicons?domain=${partner.domain}&sz=128`,
  ];

  return (
    <a
      href={partner.url}
      target="_blank"
      rel="noreferrer"
      className="group flex-shrink-0 mx-4 md:mx-6 flex items-center gap-3 md:gap-4 w-56 md:w-72 h-20 md:h-24 px-4 md:px-5 rounded-xl bg-white border border-slate-200/80 shadow-sm hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 relative overflow-hidden"
      title={partner.name}
    >
      <span className="absolute left-0 top-0 bottom-0 w-1 bg-[#4a7b9d] group-hover:bg-[#ffd86b] transition-colors duration-300" />
      {stage < 2 ? (
        <img
          src={sources[stage]}
          alt={partner.name}
          onError={() => setStage((s) => s + 1)}
          className={`flex-shrink-0 ${
            stage === 0 ? "h-10 md:h-12" : "h-7 md:h-8"
          } w-auto object-contain`}
          loading="lazy"
        />
      ) : (
        <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-[#4a7b9d] text-white flex items-center justify-center font-display text-base md:text-lg">
          {partner.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
        </div>
      )}
      <span className="font-display text-[#2d3e4a] text-sm md:text-[15px] leading-tight">
        {partner.name}
      </span>
    </a>
  );
}

export default function PartnerMarquee() {
  // Duplicate the list so the marquee can loop seamlessly
  const loop = [...partners, ...partners];

  return (
    <section className="bg-white py-16 lg:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <p className="text-[#4a6c7b] uppercase text-xs tracking-[0.22em] font-semibold">
            Trusted Partnerships
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2d3e4a] mt-4 leading-tight">
            A few of our distribution partners.
          </h2>
          <p className="mt-3 text-slate-600 text-sm">
            Click any partner to visit their website.
          </p>
        </div>
      </div>

      {/* Marquee strip — edge gradients mask scroll boundaries */}
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="marquee-track flex w-max">
          {loop.map((p, i) => (
            <LogoTile key={`${p.name}-${i}`} partner={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
